// extracted by mini-css-extract-plugin
export default {"root":"CancelByRider_root__aZcmh","confirm":"CancelByRider_confirm__5WHvC","no":"CancelByRider_no__1-bbu","yes":"CancelByRider_yes__OjVXu"};